module.exports = __webpack_public_path__ + "static/media/dot-loader.a20e6322.svg";